/**
 * PanelTextField — the light-card text input, with an optional trailing action (the seed's Random).
 */

import { CONTROL_H, MOTION, TRACK } from './tokens';

interface PanelTextFieldProps {
  value: string;
  onChange: (value: string) => void;
  onEnter?: () => void;
  placeholder?: string;
  maxLength?: number;
  inputMode?: 'text' | 'numeric';
  action?: { label: string; onClick: () => void };
  ariaLabel?: string;
}

export function PanelTextField({
  value, onChange, onEnter, placeholder, maxLength, inputMode, action, ariaLabel,
}: PanelTextFieldProps) {
  return (
    <div className="flex gap-2">
      <input
        className={`flex-1 min-w-0 ${CONTROL_H} ${TRACK} px-4 text-[13px] md:text-xs font-bold
          text-neutral-800 outline-none focus:ring-2 focus:ring-[#93CB55] ${MOTION}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter') onEnter?.(); }}
        placeholder={placeholder}
        maxLength={maxLength}
        inputMode={inputMode}
        aria-label={ariaLabel}
      />
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          className={`shrink-0 ${CONTROL_H} ${TRACK} px-3 text-xs font-bold text-neutral-600
            cursor-pointer hover:bg-neutral-200/70 ${MOTION}`}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
